export default __webpack_public_path__ + "static/media/a026-example1.8e9fa998.jpg";